import { CallMethodEnums } from '@/types/api';
import {
  UserBlockRes,
  UserDeleteRes,
  UserGetRes,
  UserRolesAddReq,
  UserRolesAddRes,
  UserRoleSetReq,
  UserRoleSetRes,
  UserRolesRemoveReq,
  UserRolesRemoveRes,
  UsersGetRes,
  UserUnblockRes
} from '@/types/user';

import { call } from './utils';

export const usersGet = async(): Promise<UsersGetRes> => {
  const json = call<undefined, UsersGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/users'
  } );

  return json;
};

export const userDelete = async( userId: string ): Promise<UserDeleteRes> => {
  const json = call<undefined, UserDeleteRes>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: '/api/users/' + userId
  } );

  return json;
};

export const userGet = async( userId: string ): Promise<UserGetRes> => {
  const json = call<undefined, UserGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/users/' + userId
  } );

  return json;
};

export const userRolesAdd = async( userId: string, roleIds: string[] ): Promise<UserRolesAddRes> => {
  const json = call<UserRolesAddReq, UserRolesAddRes>( {
    body: { role_ids: roleIds },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/users/' + userId + '/roles'
  } );

  return json;
};

export const userRolesRemove = async( userId: string, roleIds: string[] ): Promise<UserRolesRemoveRes> => {
  const json = call<UserRolesRemoveReq, UserRolesRemoveRes>( {
    body: { role_ids: roleIds },
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: '/api/users/' + userId + '/roles'
  } );

  return json;
};

export const userRoleSet = async( userId: string, role: UserRoleSetReq[ 'role' ] ): Promise<UserRoleSetRes> => {
  const json = call<UserRoleSetReq, UserRoleSetRes>( {
    body: { role },
    isProtected: true,
    method: CallMethodEnums.PATCH,
    route: '/api/users/' + userId + '/role'
  } );

  return json;
};

export const userBlock = async( userId: string ): Promise<UserBlockRes> => {
  const json = call<undefined, UserBlockRes>( {
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/users/' + userId + '/block'
  } );

  return json;
};

export const userUnblock = async( userId: string ): Promise<UserUnblockRes> => {
  const json = call<undefined, UserUnblockRes>( {
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/users/' + userId + '/unblock'
  } );

  return json;
};